module.exports = __webpack_public_path__ + "img/plan4_book05.a27994e1.png";